import { Box, Grid } from "@mui/material";
import React from "react";
import SearchScenario from "./SearchScenario";
import SelectScenario from "./SelectScenario";
import ScenarioInfoForm from "./ScenarioInfoForm";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import {
	getAllEnums,
	getCustGrpRef,
	getScSTQ,
	getTrustLevel,
} from "./editScenarioNewSlice";
import SkuPgSearchForm from "./SkuPgSearchForm";
import SkuPgSearchResult from "./SkuPgSearchResult";
import CustomerCgSearchForm from "./CustomerCgSearchForm";
import CustomerCgSearchResult from "./CustomerCgSearchResult";
import DefineLinkDataSources from "./DefineLinkDataSources";
import DefineScenarioSettings from "./DefineScenarioSettings";
import DefaultSafetyMargin from "./DefaultSafetyMargin";
import CustomerBdMethod from "./CustomerBdMethod";
import Summary from "./Summary";
import MessageForEdit from "./MessageForEdit";
import { setState, reset } from "./editScenarioNewSlice";
import { getCriticalityList, setState as setStateCreate } from "../scenarioSetupNewSlice";
import PredictionMethod from "./PredictionMethod";
import AuthorizedDeviation from "./AuthorizedDeviation";
import CollapseSection from "../../../../components/ui/CollapseSection";
import MessageForCreate from "../Create/MessageForCreate";
import ScenarioValidationPopUp from "./ScenarioValidationPopup";
import ScenarioValidationPopUpCreate from "../Create/ScenarioValidationPopupCreate";
import CloneConfirmationModal from "./CloneConfirmationModal";

export default function EditScenario() {
	const dispatch = useDispatch();
	const states = useSelector((store) => store.editScenarioNew);
	const createState = useSelector((store) => store.scenarioSetupNew);
	const { periodTypes, customerTypes, trustLevels, scenarioSTQ,predictionMethodPeriodList,previousYearPeriodList,DefaultInitialForecast, SafetyMargin, selectedcustomerTypes,criticalityList,
		section_SKU, section_Customer, section_Datasources, section_Scenario_Settings} = states;
	const {message, messageOpen, severity,createToEdit}= createState;
	useEffect(() => {
		dispatch(reset("refresh"));
		if (periodTypes.length === 0) {
			dispatch(getAllEnums());
		}
		if (customerTypes.length === 0) {
			dispatch(getCustGrpRef());
		}
		if (trustLevels.length === 0) {
			dispatch(getTrustLevel());
		}
		if (scenarioSTQ.length === 0) {
			dispatch(getScSTQ());
		}
		if (criticalityList.length === 0) {
			dispatch(getCriticalityList());
		}
		if(createToEdit){
			dispatch(setState("messageOpen", messageOpen));
			dispatch(setState("message", message));
			dispatch(setState("severity", severity));
			dispatch(setStateCreate("createToEdit", false));
		}
	}, []);

	return (
		<Box>
			<Box>
				<MessageForEdit />
			</Box>
			<ScenarioValidationPopUp />
			<ScenarioValidationPopUpCreate />
			<CloneConfirmationModal />
			<Grid  container spacing={2}>
				<Grid item lg={6} xs = {12}>
					<SearchScenario />
				</Grid >
				<Grid item lg={5.8} xs = {12}>
					<SelectScenario />
				</Grid>
			</Grid>
			<ScenarioInfoForm />
			<CollapseSection title="Select SKUs/Product Groups">
			{/* isError = {section_SKU} */}
			<Grid container spacing={2}>
				<Grid item lg={2.25} xs = {12}>
					<SkuPgSearchForm />
					</Grid>
				<Grid item lg={9.75} xs = {12} >
					<SkuPgSearchResult />
				</Grid>
			</Grid>
			</CollapseSection>
			<CollapseSection title="Select Customer Groups/Customers">
			{/* isError = {section_Customer} */}
			<Grid container spacing={2}>
				<Grid item lg={2.25} xs = {12}>
					<CustomerCgSearchForm />
				</Grid>
				<Grid item lg={9.75} xs = {12}>
					<CustomerCgSearchResult />
				</Grid>
			</Grid>
			</CollapseSection>	
			<CollapseSection title="Define and Link Data Sources">
			{/* isError = {section_Datasources} */}
				<DefineLinkDataSources />
			</CollapseSection>
			<CollapseSection title="Define Scenario Settings">
			{/* isError = {section_Scenario_Settings} */}
			<Grid container spacing={2}>
				<Grid item lg={5.9} xs = {12}>
					<DefineScenarioSettings />
					<DefaultSafetyMargin />
					<CustomerBdMethod />
				</Grid>
				<Grid item lg={5.9} xs = {12} sx={{ ml: 2, mt : 4, borderLeft: 1, borderColor: "#c6c6c6" }}>
					<PredictionMethod />
					<AuthorizedDeviation />
				</Grid>
			</Grid>
			</CollapseSection>
			<Summary />
		</Box>
	);
}